import React from "react";
import { AppLayOut } from "../../components/layout/AppLayOut";
import BackButton from "../../components/backbutton/BackButton";

const BestSellersPage = () => {
  return (
    <AppLayOut>
    <BackButton></BackButton>
      <div>Best Sellers</div>
    </AppLayOut>
  );
};

export default BestSellersPage;
